<template>
  <section class="pleasure">
    <div class="longImg"></div>
    <div class="content">
      <div class="mix">
        <div class="m_head">
          <img src="../../assets/img/zuoj.png" alt="">
          <p>乐璟天地·LOGIN MIX</p>
          <img src="../../assets/img/zuoj.png" alt="">
        </div>
        <div class="m_main">
          <div class="left">
            <ul>
              <li v-for="(item, index) in icons" :key="index" @mouseover="showImg(index)" :class="active===index?'active':''">
                <i class="m_icon" :style="item.position"></i>
                <span>{{item.name}}</span>
              </li>
            </ul>
          </div>
          <div class="right" style="">
            <transition-group name = "slide-fade">
              <img v-for="(item, index) in img" :key="index" v-show="active === index" :src="item" >
            </transition-group>
          </div>
        </div>
      </div>
      <div class="brand">
        <div class="b_head">
          <img src="../../assets/img/zuoj.png" alt="">
          <p>乐璟独创的商业连锁品牌</p>
          <img src="../../assets/img/zuoj.png" alt="">
        </div>
        <div class="b_main">
          <div class="left"></div>
          <div class="right"></div>
        </div>
      </div>
      <div class="reform">
        <div class="r_head">
          <p>通过改建翻新，激发社区商业活力</p>
          <div class="lineimg"></div>
        </div>
        <div class="r_imgs">
          <div class="img1"></div>
          <div class="img2"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import canyy from '../../assets/img/canyy.png'
  import chaoshi from '../../assets/img/chaoshi.png'
  import yinh from '../../assets/img/yinh.png'
  import youju from '../../assets/img/youju.png'
  import dianxin from '../../assets/img/dianxin.png'
  import yaofang from '../../assets/img/yaofang.png'
  import jiansf from '../../assets/img/jiansf.png'
  import dianj from '../../assets/img/dianj.png'
  import bangong from '../../assets/img/bangong.png'
  import meifa from '../../assets/img/meifa.png'
  import xiyif from '../../assets/img/xiyif.png'
  import yuels from '../../assets/img/yuels.png'
  import jiaoy from '../../assets/img/jiaoy.png'
  import kgff from '../../assets/img/kgff.png'
  export default {
    data () {
      return {
        img: [canyy, chaoshi, yinh, youju, dianxin, yaofang, jiansf, dianj, bangong, meifa, xiyif, yuels, jiaoy, kgff],
        icons: [{
          name: '餐饮', img: 'canyy', position: {'background-position': '0 -2px'},
        }, {
          name: '超市', img: 'chaoshi', position: {'background-position': '-21px -1px'},
        }, {
          name: '银行', position: {'background-position': '-43px -2px'},
        }, {
          name: '邮局', position: {'background-position': '-65px -2px'},
        }, {
          name: '电信', position: {'background-position': '-85px -1px'},
        }, {
          name: '药房', position: {'background-position': '-1px -22px'},
        }, {
          name: '健身', position: {'background-position': '-21px -22px'},
        }, {
          name: '电竞', position: {'background-position': '-44px -23px'},
        }, {
          name: '办公', position: {'background-position': '-65px -22px'},
        }, {
          name: '美发', position: {'background-position': '-85px -22px'},
        }, {
          name: '洗衣', position: {'background-position': '-1px -41px'},
        }, {
          name: '阅览室', position: {'background-position': '-21px -42px'},
        }, {
          name: '教育', position: {'background-position': '-43px -43px'},
        }, {
          name: 'Ｋ歌房', position: {'background-position': '-64px -42px'},
        }],
        active: 0
      }
    },
    methods: {
      showImg(index) {
        this.active = index
      }
    }
  }
</script>

<style lang="stylus">

  .slide-fade-enter-active {
    transition: all .6s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s ease
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
    transform: translateX(10px);
    opacity: 0;
  }
  .pleasure

    font-family PingFangSC-Medium
    padding-bottom 174px

    .longImg
      background:url(../../assets/img/bannerljtd.png) no-repeat
      height: 600px
    .content
      width 1120px
      margin 0 auto
      .mix
        margin-top 95px
        .m_head
          display: flex
          align-items: center
          justify-content: space-between
          p
            color #272727
            font-size 38px
            font-weight 500
          img
            width 320px
          img:last-child
            transform rotate(180deg)
        .m_main
          margin-top 75px
          display flex
          .left
            width 382px
            height 363px
            ul
              padding 24px 2px
              overflow hidden
              font-family PingFangSC-Regular
              li
                display flex
                float left
                width 96px
                height 32px
                align-items center
                font-size 18px
                color #666666
                font-weight 400
                cursor pointer
                margin-right 30px
                margin-bottom 30px
                box-shadow:0px 0px 0px 0px rgba(0,0,0,0.5)
                transition all 0.3s
                i
                  margin 0 7px 0 10px
                  background:url(../../assets/img/icons.png) no-repeat
                  width 20px
                  height 20px
                  display block
              .active
                border-radius 16px
                box-shadow:0px 2px 8px 1px rgba(80,181,208,0.29)
                transition all 0.5s

          .right
            width 738px
            height 363px
            overflow: hidden;
      .brand
        margin-top 126px
        .b_head
          display: flex
          align-items: center
          justify-content: space-between
          p
            color #272727
            font-size 38px
            font-weight 500
          img
            width 300px
          img:last-child
            transform rotate(180deg)
        .b_main
          margin-top 80px
          display flex
          justify-content space-between
          div
            width 540px
            height 326px
          .left
            background:url(../../assets/img/lspp1.png) no-repeat
          .right
            background:url(../../assets/img/lspp2.png) no-repeat
      .reform
        margin-top 119px
        .r_head
          color #272727
          font-size 38px
          font-weight 500
          p
            margin 0 0 26px 5px
          .lineimg
            background:url(../../assets/img/jiabl.png) no-repeat
            height 4px

        .r_imgs
          height 360px
          display flex
          justify-content space-between
          padding-top 36px
          .img1
            width 538px
            background:url(../../assets/img/ljtdgzq.png) no-repeat
          .img2
            width 538px
            background:url(../../assets/img/ljtdgzh.png) no-repeat

</style>
